import React from "react";
import Head from "next/head";
import { Box, Flex } from "@chakra-ui/react";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

import { Image } from "@/components/common/Image";
import UserMenu from "./Header/UserMenu";
import LanguageSwitcher from "./Header/LanguageSwitcher";

type LayoutProps = {
  title?: string;
  children: React.ReactNode;
};

const CleanLayout = ({ title, children }: LayoutProps): React.ReactElement => {
  return (
    <>
      <Head>
        {title && <title>{title} - Accred.eu</title>}
        <script src="https://platform.twitter.com/widgets.js"></script>
      </Head>

      <Flex px={{ base: ".75rem", md: "2rem" }} direction="column" mb="2rem">
        <Flex
          height="70px"
          justifyContent="space-between"
          alignItems="center"
          zIndex={999}
        >
          <Box width="162px" height="100%" position="relative">
            <Image
              priority
              src={`${publicRuntimeConfig.basePath}/logo.svg`}
              objectFit="contain"
              objectPosition="left"
              alt=""
            />
          </Box>
          <Flex alignItems="center" gap={2}>
            <LanguageSwitcher isPanel />
            <UserMenu />
          </Flex>
        </Flex>
        <Box
          position="relative"
          borderRadius="30px"
          p={{ base: "0 1rem 1rem", md: "0 22px 2.5rem" }}
          minHeight="calc(100vh - 6.5rem)"
          flex="1 1 0%"
          bg="light.100"
        >
          {children}
        </Box>
      </Flex>
    </>
  );
};

export default CleanLayout;
